const Hero = {
  el: {
    hero: document.querySelector<HTMLElement>('.hero'),
  },

  init() {
    // checking if hero exists
    if (this.el.hero) {
      const nextElementSibling = this.el.hero.nextElementSibling as HTMLElement
      const isInvestorStatsBlock = nextElementSibling.classList.contains('investor-stats-block')
      const heroSvg = document.querySelector<HTMLElement>('.hero__svg')
      const heroVideoComponent = document.querySelector<HTMLElement>('.hero__video-container')

      //only run this if the first block after hero is investor stats block
      if (isInvestorStatsBlock && heroSvg != null) {
        //run this on load
        this.renderMargin(nextElementSibling, heroSvg)
      }

      //only run this if hero video component exists
      if (heroVideoComponent) {
        this.setHeroVideoSpacing(heroVideoComponent)
      }

      //run again on resize
      window.addEventListener('resize', () => {
        if (isInvestorStatsBlock && heroSvg != null) {
          this.renderMargin(nextElementSibling, heroSvg)
        }

        if (heroVideoComponent) {
          this.setHeroVideoSpacing(heroVideoComponent)
        }
      })
    }
  },

  renderMargin(nextElementSibling: HTMLElement, heroSvg: HTMLElement) {
    if (window.innerWidth < 992) {
      nextElementSibling.style.marginTop = `${heroSvg.clientHeight / 4 + 60}px`
    } else {
      nextElementSibling.style.marginTop = '0px'
    }
  },

  setHeroVideoSpacing(heroVideoComponent: HTMLElement) {
    if (window.innerWidth < 992) {
      this.el.hero.style.paddingBottom = `${(heroVideoComponent.clientHeight / 2) + 40}px`
      this.el.hero.style.marginBottom = `${(heroVideoComponent.clientHeight / 2) + 60}px`
    } else {
      this.el.hero.style.paddingBottom = '90px'
      this.el.hero.style.marginBottom = '160px'
    }
  }
}

export default Hero
